import { render, staticRenderFns } from "./VxTooltip.vue?vue&type=template&id=1b33871f&scoped=true"
import script from "./VxTooltip.vue?vue&type=script&lang=js"
export * from "./VxTooltip.vue?vue&type=script&lang=js"
import style0 from "./VxTooltip.vue?vue&type=style&index=0&id=1b33871f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b33871f",
  null
  
)

export default component.exports